const state = {
  isAuthenticated: false
}

const mutations = {
  setAuthenticated: (state, newValue) => (
    state.isAuthenticated = newValue
  )
}

const getters = {}
const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth-module.js